module.exports = __webpack_public_path__ + "18_hair_brown.d79091e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/18_hair_brown.png
// module id = FPyX
// module chunks = 0